import { render, staticRenderFns } from "./backClient.vue?vue&type=template&id=f92488a2&scoped=true&"
import script from "./backClient.vue?vue&type=script&lang=js&"
export * from "./backClient.vue?vue&type=script&lang=js&"
import style0 from "./backClient.vue?vue&type=style&index=0&id=f92488a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92488a2",
  null
  
)

export default component.exports